import {Component} from '@angular/core';


@Component({
  selector: 'app-edit-betrieb-fakturierung',
  templateUrl: './content-only.component.html',
  styleUrls: ['./content-only.component.scss']
})
export class ContentOnlyComponent {

}
